import React, { useCallback, useEffect, useState } from "react";
import InputField from "../forms/input-field";
import TextAreaField from "../forms/textarea-field";
import PaymentAddressIcon from "../../assets/icons/admin-customer-icons/payment-address";
import AddButton, { DeleteButton } from "../buttons/button";
import DeleteIcon from "../../assets/icons/delete-icon";
import { Form, Formik, useFormikContext } from "formik";
import errorToast from "../helper-components/error-toast";
import { useDispatch } from "react-redux";
import * as Yup from "yup";
import {
  acquiredSourceAction,
  adminCustomerCreateAction,
  adminCustomerEditAction,
  adminCustomerUpdateAddressAction,
  adminCustomerUpdateContactPersonAction,
  groupAction,
  paymentTermsAction,
  relationAction,
} from "../../redux/actions/admin-customer-action";
import LoadingOverlay from "../helper-components/overlay-loading";
import successToast from "../helper-components/success-toast";
import DatePicker from "react-datepicker";
import ItemsInputField from "../forms/items-input-field";
import SelectField from "../forms/select-field";
import { customerTypeoptions } from "../helper-components/data";
import {
  pincodeListAction,
  priceListAction,
  sectorListAction,
  shippingTypeListAction,
  storeListAction,
  taxCatListAction,
} from "../../redux/actions/general-action";
import UploadImg from "./uploadImg";
import CheckBox from "./checkBox";
import UpdateTabs from "./updateTabs";
import { json, Navigate, useNavigate } from "react-router-dom";
import moment from "moment";
import {
  leadSearchListAction,
  partyCatogerySearchListAction,
  partyGroupSearchListAction,
  partyListAction,
  paymentSearchListAction,
  tcsTaxListAction,
  tdsTaxListAction,
} from "../../redux/actions/settings-action";
import { api } from "../../redux/apis/api";
import axios from "axios";
import { isAdmin, url } from "../../redux/config";
import InputPhoneField from "../forms/phone-input-field";
import { use } from "react";

function General({
  customerId,
  general,
  page,
  disabled,
  // loading,
  // setLoading,
  setCurrentTab,
  setTabs,
  setGeneralCreated,
  setCustomerId,
  setContactId,
  setPay,
  setShipping,
  setBanking,
  setFamily,
  setInsurance,
  setPatient,
  setPayment,
  customization,
}) {
  const [defaultPay, setDefaultPay] = useState("");
  const [defaultShipping, setDefaultShipping] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentList, setPaymentList] = useState(null);
  const [taxList, setTaxList] = useState([]);
  const [shippingTypeList, setShippingTypeList] = useState([]);
  const [sectorList, setSectorList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [acquiredList, setAcquiredList] = useState([]);
  const [tcslist, setTcslist] = useState([]);
  const [tdslist, setTdslist] = useState([]);
  const [partyList, setPartyList] = useState([]);
  const [customData, setcustomData] = useState([]);
  // const [areaList, setAreaList] = useState([]);

  const [list, setList] = useState(null);
  const [storelist, setStorelist] = useState([]);

  const localStorageData = JSON.parse(localStorage.getItem("customerAdmin"));
  const navigate = useNavigate();

  const dispatch = useDispatch();

  let initialValues = {
    general: localStorageData?.general ?? general,
  };
  initialValues.general.cmr_dob = moment(initialValues.general.cmr_dob).format(
    "YYYY-MM-DD"
  );

  function convertArray(input) {
    return input.map((item) => ({
      value: item.name,
      label: item.name,
    }));
  }
  function convertPriceList(input) {
    return input.map((item) => ({
      value: item.price_list_id,
      label: item.price_list_name,
    }));
  }
  const onSuccess = (data) => {
    setContactId(data?.data.contacts[0].cmr_contact_person_id); //
    setPay(data?.data.addressPay[0].cmr_pay_address_id); //
    setShipping(data?.data.addressShipping[0].cmr_ship_address_id);
    setBanking(data?.data.banking[0].cmr_bank_id);
    setFamily(data?.data.family[0].cmr_family_id); //
    setInsurance(data?.data.insurance[0].cmr_policy_id);

    setPatient(data?.data.patient.cmr_patient_id);
    setPayment(data?.data.payment.cmr_payment_terms_id);

    setCustomerId(data?.data?.general.cmr_id);

    //

    // localStorageData.setItem(
    //   "customerId",
    //   JSON.stringify(data?.data?.general.cmr_id)
    // );
    //

    //

    const existingData = JSON.parse(localStorage.getItem("customerAdmin"));
    const updatedData = {
      general: { ...existingData.general },
      contacts: data?.data.contacts,
      addressPay: data?.data.addressPay,
      addressShipping: data?.data.addressShipping,
      banking: data?.data.banking,
      family: data?.data.family,
      insurance: data?.data.insurance,

      patient: data?.data.patient,
      payment: data?.data.payment,

      customerId: data?.data?.general.cmr_id,
    };
    localStorage.setItem("customerAdmin", JSON.stringify(updatedData));

    setLoading(false);
    setGeneralCreated(true);
    successToast(data.message);
    // successToast("success");
    console.log("onSuccess data", data);
    setCurrentTab("Contacts");
  };
  const onUpdateSuccess = (data) => {
    console.log("update success", data);
    setLoading(false);
    successToast(data?.message);
    setCurrentTab("Contacts");
  };
  const onUpdateError = (data) => {
    console.log("update failed", data);
    setLoading(false);
    errorToast(data.message);
  };
  const onListSuccess = (data) => {
    const res = convertArray(data.data);
    setList(res);
    setLoading(false);
  };
  const onPaymentSuccess = (data) => {
    setPaymentList(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );

    setLoading(false);
  };
  const onError = (data) => {
    setLoading(false);
    // errorToast(data?.message);
    errorToast(data.data.message);
    console.log("onError data", data);
  };
  const ontaxCatSuccess = (data) => {
    setTaxList(
      data?.data?.map((item) => {
        return { label: item?.code, value: item?.id };
      })
    );
  };
  const onshippingTypeSuccess = (data) => {
    setShippingTypeList(
      data?.data?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onsectorSuccess = (data) => {
    setSectorList(
      data?.data?.sector?.map((item) => {
        return { label: item?.sector, value: item?.sector };
      })
    );
  };
  const ontaxCatError = (data) => {
    // errorToast(data?.message);
  };
  const onshippingTypeError = (data) => {
    setShippingTypeList([]);
  };
  const onsectorError = (data) => {
    // errorToast(data?.message);
  };
  const onGroupSuccess = (data) => {
    setGroupList(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onGroupError = (data) => {
    console.log("group fail", data);
  };
  const onAcquiredSuccess = (data) => {
    setAcquiredList(
      data?.data?.list?.map((item) => {
        return { label: item?.name, value: item?.id };
      })
    );
  };
  const onAcquiredError = (data) => {
    console.log("Acquired fail", data);
  };
  const onSuccessTcs = (data) => {
    setTcslist(
      data?.data?.map((item) => ({
        label: item?.tcs_name,
        value: item?.tcs_id,
      }))
    );
  };
  const onErrorTcs = (data) => {};
  const onSuccessTds = (data) => {
    setTdslist(
      data?.data?.map((item) => ({
        label: item?.tds_name,
        value: item?.tds_id,
      }))
    );
  };
  const onSuccessParty = (data) => {
    setPartyList(
      data?.data?.list?.map((item) => ({
        label: item?.name,
        value: item?.id,
      }))
    );
  };
  const onErrorTds = (data) => {};

  useEffect(() => {
    if (!loading) {
      setLoading(true);
      dispatch(relationAction(onListSuccess, onError));
      // dispatch(paymentTermsAction(onPaymentSuccess, onError));

      dispatch(paymentSearchListAction("", onPaymentSuccess, onError));

      dispatch(taxCatListAction(ontaxCatSuccess, ontaxCatError));
      dispatch(
        shippingTypeListAction(onshippingTypeSuccess, onshippingTypeError)
      );
      dispatch(sectorListAction(onsectorSuccess, onsectorError));
      dispatch(partyGroupSearchListAction("", onGroupSuccess, onGroupError));
      dispatch(partyCatogerySearchListAction("", onSuccessParty, onErrorTds));

      // dispatch(groupAction(onGroupSuccess, onGroupError));
      // dispatch(acquiredSourceAction(onAcquiredSuccess, onAcquiredError));
      dispatch(leadSearchListAction("", onAcquiredSuccess, onAcquiredError));

      dispatch(tcsTaxListAction("", onSuccessTcs, onErrorTcs));
      dispatch(tdsTaxListAction("", onSuccessTds, onErrorTds));
      // dispatch(partyListAction("", onSuccessParty, onErrorTds));
    }
  }, []);
  useEffect(() => {
    try {
      const existingData = JSON.parse(
        localStorage.getItem("customerAdmin") || null
      );
      if (existingData?.customerId) {
        setCustomerId(existingData.customerId);
        setGeneralCreated(true);
      }
    } catch (err) {
      console.error("Invalid localStorage data for customerAdmin:", err);
    }
  }, []);

  useEffect(() => {
    if (customization) {
      let data = customization.filter((item) => item?.label === "general");
      setcustomData(data?.[0]?.childrenHeading);
    }
  }, [customization]);

  const handleUploadSuccess = useCallback((fieldName, imageUrl) => {
    // Force localStorage update
    const existingData =
      JSON.parse(localStorage.getItem("customerAdmin")) || {};
    const updatedData = {
      ...existingData,
      general: {
        ...existingData.general,
        [fieldName.replace("general.", "")]: imageUrl,
      },
    };
    localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
  }, []);

  const UpdateLocalStorage = ({ values }) => {
    const [isInitialRender, setIsInitialRender] = useState(true);

    useEffect(() => {
      // if (page === "add") {
      if (isInitialRender) {
        setIsInitialRender(false);
        return; // Skip the first render
      }

      console.log("Updating localStorage with values:", values);
      try {
        const existingData =
          JSON.parse(localStorage.getItem("customerAdmin")) || {};
          const params = new URLSearchParams(window.location.search);
          const phone = params.get("phoneNumber");

          const updatedData = {
            ...existingData,
            general: {
              ...values.general,
              ...(phone ? { cmr_phone_number: phone } : {}), // only override if phone exists
            },
          };
        localStorage.setItem("customerAdmin", JSON.stringify(updatedData));
      } catch (error) {
        console.error("Error updating localStorage:", error);
      }
      // }
    }, [values.general, isInitialRender]);

    return null;
  };
  useEffect(() => {
    return () => setLoading(false);
  }, []);
  const onSave = (values, { validateForm, errors }) => {
    console.log("general cmr id", customerId);
    if (loading) return;
    setLoading(true);
    if (values.general.cmr_dob === "Invalid date")
      delete values.general.cmr_dob;
    let actionType = adminCustomerCreateAction;
    if (customerId) {
      actionType = adminCustomerEditAction;
    }
    delete values.general.areaList;
    const submittedValues = {
      ...values.general,
      cmr_id: customerId,
      cmr_gstin_certificate: values.general.cmr_gstin_certificate,
      cmr_dl_certificate: values.general.cmr_dl_certificate,
      cmr_fssai_certificate: values.general.cmr_fssai_certificate,
    };
    // if (customData) return postData(values.general);
    dispatch(
      actionType(
        // customerId ? submittedValues : values.general,
        page === "add" && customerId ? submittedValues : values.general,
        customerId ? onUpdateSuccess : onSuccess,
        customerId ? onUpdateError : onError
      )
    );
  };
  //
  // const postData = (data) => {
  //   axios
  //     .post("https://dev.zotanextech.com/api/customer/generalDetails/add", data)
  //     .then((res) => {
  //       setLoading(false);
  //       successToast(res.message);
  //     })
  //     .catch((res) => {
  //       setLoading(false);
  //       errorToast(res.error);
  //     });
  // };

  //
  // function updateList(data) {
  //   setAreaList(
  //     data.map((item) => ({
  //       label: item?.Name,
  //       value: item?.Name,
  //     }))
  //   );
  // }


  const fetchAddressFn = useCallback(
    (inputValue, setFieldValue) => {
      if (inputValue?.length === 6) {
        dispatch(
          pincodeListAction(
            inputValue,
            (response) => {
              if (response?.[0]?.Status === "Error") {
              } else {
                const firstPostOffice = response?.[0]?.PostOffice?.[0];
                // updateList(response?.[0]?.PostOffice);

                setFieldValue("general.cmr_state", firstPostOffice?.State);
                setFieldValue("general.cmr_city", firstPostOffice?.Division);
                setFieldValue("general.cmr_town", firstPostOffice?.Block);
                // setFieldValue("general.cmr_village", firstPostOffice?.Name);

                setFieldValue(
                  "general.areaList",
                  response?.[0]?.PostOffice?.map((item) => ({
                    label: item?.Name,
                    value: item?.Name,
                  }))
                );
              }
            },
            (data) => {
              setFieldValue("general.cmr_state", "");
              setFieldValue("general.cmr_city", "");
              setFieldValue("general.cmr_town", "");
              setFieldValue("general.cmr_village", []);
            }
          )
        );
      } else {
        setFieldValue("general.cmr_state", "");
        setFieldValue("general.cmr_city", "");
        setFieldValue("general.cmr_town", "");
        setFieldValue("general.cmr_village", []);
      }
    },
    [dispatch]
  ); // Add dependencies
  function trimApiPrefix(link) {
    const prefix = `${url}/image/`; // has to be updated based on domain
    return link.startsWith(prefix) ? link.slice(prefix.length) : link;
  }
  // Email validation regex
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^[0-9]\d{9}$/;
  const gstinRegex =
    /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
  const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
  const pincodeRegex = /^[1-9][0-9]{5}$/;
  const fssaiRegex = /^[0-9]{14}$/;
  const dlRegex = /^[A-Z]{2}[0-9]{2}[0-9]{4}[0-9]{7}$/;
  const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

  const validationSchema = Yup.object().shape({
    general: Yup.object().shape({
      // Core Information
      cmr_first_name: Yup.string()
        // .required("Full Name is required")
        .min(2, "Full Name must be at least 2 characters")
        .max(100, "Full Name must not exceed 100 characters"),

      cmr_type: Yup.string()
        // .required("Party Type is required")
        .oneOf(["individual", "business"], "Invalid party type"),

      cmr_phone_number: Yup.string()
        .required("Phone is required")
        .matches(
          phoneRegex,
          "Please enter a valid 10-digit phone number starting with 6-9"
        ),

      cmr_email: Yup.string()
        .nullable()
        .matches(emailRegex, "Please enter a valid email address"),

      cmr_balance: Yup.number()
        .min(0, "Balance cannot be negative")
        .max(999999999, "Balance amount is too large"),

      // Location fields
      cmr_pincode: Yup.string().matches(
        pincodeRegex,
        "Please enter a valid 6-digit pincode"
      ),
      cmr_pan: Yup.string()
        .nullable()
        .test(
          "pan-validation",
          "Please enter a valid PAN number (e.g., ABCDE1234F)",
          function (value) {
            // If PAN is null, undefined, or empty string, skip validation
            if (!value || value.trim() === "") {
              return true;
            }
            // If PAN has a value, validate it
            return panRegex.test(value.toUpperCase());
          }
        ),

      cmr_gstin: Yup.string()
        .nullable()
        .test(
          "gst-validation",
          "Please enter a valid GST number (15 digits)",
          function (value) {
            // If GST is null, undefined, or empty string, skip validation
            if (!value || value.trim() === "") {
              return true;
            }
            // If GST has a value, validate it
            return gstRegex.test(value.toUpperCase());
          }
        ),
      // cmr_state: Yup.string().max(50, "State name is too long"),

      // cmr_city: Yup.string()
      //   // .min(2, "City name is too short")
      //   .max(50, "City name is too long"),

      // cmr_town: Yup.string()
      //   // .min(2, "Region name is too short")
      //   .max(50, "Region name is too long"),

      // cmr_village: Yup.string()
      //   // .min(2, "Area name is too short")
      //   .max(50, "Area name is too long"),

      // PAN for business (if you have this field)
      // cmr_pan: Yup.string().when("cmr_type", {
      //   is: "business",
      //   then: (schema) =>
      //     schema.matches(
      //       panRegex,
      //       "Please enter a valid PAN format (e.g., ABCDE1234F)"
      //     ),
      //   otherwise: (schema) => schema.notRequired(),
      // }),

      cmr_remarks: Yup.string().max(
        1000,
        "Remarks must not exceed 1000 characters"
      ),
    }),
  });
  function handelenabled(key) {
    if (page === "view") return true;
    let a = customData?.find((item) => item.value === key);
    // console.log("handelEnabled", !a?.enabled);
    return !a?.enabled;
  }
  function shouldDisplay(key) {
    let a = customData?.find((item) => item.value === key);
    // console.log("handelEnabled", !a?.enabled);
    return a?.enabled;
  }
  function handelLabel(key) {
    let a = customData?.find((item) => item.value === key);
    // console.log("Label==", a?.label);
    return a?.label;
  }
  const onSuccessstore = (data) => {
    setStorelist(
      data?.data?.map((item) => ({
        label: item?.concated_store_name,
        value: item?.store_id,
      }))
    );
    let a = data?.data?.map((item) => ({
      label: item?.concated_store_name,
      value: item?.store_id,
    }));
    console.log("aaaaaaaaaaaaaaaaaaa", a);
  };
  const onErrorstore = (data) => {};
  useEffect(() => {
    dispatch(storeListAction(onSuccessstore, onErrorstore));
  }, []);
  const today = new Date().toISOString().split("T")[0];
  return (
    <Formik
      enableReinitialize
      initialValues={{ ...initialValues, areaList: [] }}
      validationSchema={validationSchema}
      onSubmit={onSave}
    >
      {({
        values,
        setFieldValue,
        resetForm,
        setValues,
        validateForm,
        errors,
      }) => (
        <Form
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault(); // Stop form submit
            }
          }}
        >
          {console.log("general values", values)}
          <UpdateTabs setTabs={setTabs} />
          <UpdateLocalStorage values={values} />
          <LoadingOverlay isLoading={loading} />
          <CreateAreaList />
          <div className=" flex flex-col gap-6 mt-6">
            <div className="px-[34px] pt-[34px] pb-[10px]  flex-col  rounded-2xl  bg-gradient-to-br from-[var(--customer-input-section-from-bg)] to-blue-[var(--customer-input-section-to-bg)]/0 border-[2px] border-[var(--customer-input-border-color)]">
              <div className="flex  mb-6 justify-between">
                <div className="flex flex-row gap-4">
                  <PaymentAddressIcon />
                  <div className="h-full flex flex-col justify-between">
                    <label className="h-full text-[length:var(--customer-sub-title-fs)] font-[var(--customer-current-nav-fw)]">
                      Core Information
                    </label>
                    <label className="text-[length:var(--customer-current-nav-fs)] font-[var(--customer-nav-fw)]">
                      Essential details about the party
                    </label>
                  </div>
                </div>
              </div>
              <div
                className="grid  gap-x-3 gap-y-0 min-w-0"
                style={{
                  gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                }}
              >
                {shouldDisplay("cmr_first_name") && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      // isRequired={true}
                      allowSpecial={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`general.cmr_first_name`}
                      placeholder={`Enter ${handelLabel("cmr_first_name")}`}
                      label={handelLabel("cmr_first_name")}
                      isDisabled={handelenabled("cmr_first_name")}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
             `}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}
                {shouldDisplay("cmr_type") && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={customerTypeoptions?.find(
                        (option) => option?.value === values?.general?.cmr_type
                      )}
                      label={handelLabel("cmr_type")}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelenabled("cmr_type")}
                      // errMsgContainerClass="hidden"
                      id={`general.cmr_type`}
                      placeholder={`Select ${handelLabel("cmr_type")}`}
                      options={customerTypeoptions}
                      name={`general.cmr_type`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}
                {shouldDisplay("cmr_phone_number") && (
                  <div className="col-span-1">
                    <InputPhoneField
                      // errMsgContainerClass="hidden"
                      // type="number"
                      // maxLength={10}
                      isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`general.cmr_phone_number`}
                      placeholder={`Enter ${handelLabel("cmr_phone_number")}`}
                      label={handelLabel("cmr_phone_number")}
                      isDisabled={handelenabled("cmr_phone_number")}
                      defaultInputClass={`min-h-[42px] rounded-r-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)]   placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
             `}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}
                {shouldDisplay("cmr_email") && (
                  <div className="col-span-1">
                    <InputField
                      // errMsgContainerClass="hidden"
                      onKeyDown={() => {}}
                      allowSpecial={true}
                      // isRequired={true}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      parentClass="flex  flex-col gap-2 w-full align-end "
                      name={`general.cmr_email`}
                      placeholder={`Enter ${handelLabel("cmr_email")}`}
                      label={handelLabel("cmr_email")}
                      isDisabled={handelenabled("cmr_email")}
                      defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
             `}
                      containerClass="w-full h-min"
                    />
                  </div>
                )}

                {values.general.cmr_type === "individual" &&
                  shouldDisplay("cmr_dob") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        type="date"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_dob`}
                        placeholder={`Enter ${handelLabel("cmr_dob")}`}
                        label={handelLabel("cmr_dob")}
                        isDisabled={handelenabled("cmr_dob")}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
             `}
                        max={today}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                {shouldDisplay("cmr_group_id") && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={groupList?.find(
                        (option) =>
                          option?.value === values?.general?.cmr_group_id
                      )}
                      label={handelLabel("cmr_group_id")}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelenabled("cmr_group_id")}
                      // errMsgContainerClass="hidden"
                      id={`general.cmr_group_id`}
                      placeholder={`Select ${handelLabel("cmr_group_id")}`}
                      options={groupList}
                      name={`general.cmr_group_id`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}

                {values.general.cmr_type === "business" &&
                  shouldDisplay("cmr_gstin") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        maxLength={15}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_gstin`}
                        placeholder={`Enter ${handelLabel("cmr_gstin")}`}
                        label={handelLabel("cmr_gstin")}
                        isDisabled={handelenabled("cmr_gstin")}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
             `}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                {shouldDisplay("cmr_party_category") && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={partyList?.find(
                        (option) =>
                          option?.value === values?.general?.cmr_party_category
                      )}
                      label={handelLabel("cmr_party_category")}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      isDisabled={handelenabled("cmr_party_category")}
                      // errMsgContainerClass="hidden"
                      id={`general.cmr_party_category`}
                      placeholder={`Select ${handelLabel(
                        "cmr_party_category"
                      )}`}
                      options={partyList}
                      name={`general.cmr_party_category`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}

                {shouldDisplay("store_id") && isAdmin && (
                  <div className="col-span-1">
                    <SelectField
                      defaultValue={storelist?.find(
                        (option) => option?.value === values?.general?.store_id
                      )}
                      // label={handelLabel("store_id")}
                      label={"Store Mapping"}
                      labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                      general_color="true"
                      borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                      isContainer={true}
                      containerClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      parentClass={`${
                        disabled ? "cursor-not-allowed" : ""
                      } w-full flex flex-col gap-2`}
                      // isDisabled={handelenabled("store_id")}
                      isDisabled={disabled}
                      // errMsgContainerClass="hidden"
                      id={`general.store_id`}
                      // placeholder={`Select ${handelLabel("store_id")}`}
                      placeholder="Select Store id"
                      options={storelist}
                      name={`general.store_id`}
                      isSearchable={true}
                      // isRequired={true}
                    />
                  </div>
                )}
              </div>

              {values.general.cmr_type === "business" &&
                shouldDisplay("cmr_gstin_certificate") && (
                  <div className="flex gap-3 mb-5">
                    <UploadImg
                      title={handelLabel("cmr_gstin_certificate")}
                      name={"cmr_gstin_certificate"}
                      onUploadSuccess={handleUploadSuccess}
                      data={trimApiPrefix(values.general.cmr_gstin_certificate)}
                    />
                  </div>
                )}
              {(shouldDisplay("is_ecommerce_cmr") ||
                shouldDisplay("is_vendor_cmr") ||
                shouldDisplay("is_corporate_cmr") ||
                shouldDisplay("is_store_cmr") ||
                shouldDisplay("inter_company_sync")) && (
                <section className="p-4 mt-[4px] mb-6 bg-[var(--customer-business-bg)] border-[var(--customer-business-border)] rounded-lg">
                  <label className="text-[var(--alert-management-label-color)] text-[length:var(--customer-current-nav-fs)] font-[var(--alert-management-sub-title-fw)] w-full">
                    Business Associations
                  </label>
                  <div className="flex flex-row justify-between">
                    <CheckBox
                      label={handelLabel("is_ecommerce_cmr")}
                      name="is_ecommerce_cmr"
                      disabled={handelenabled("is_ecommerce_cmr")}
                    />
                    <CheckBox
                      label={handelLabel("is_vendor_cmr")}
                      disabled={handelenabled("is_vendor_cmr")}
                      name="is_vendor_cmr"
                    />
                    <CheckBox
                      label={handelLabel("is_corporate_cmr")}
                      disabled={handelenabled("is_corporate_cmr")}
                      name="is_corporate_cmr"
                    />
                    <CheckBox
                      label={handelLabel("is_store_cmr")}
                      disabled={handelenabled("is_store_cmr")}
                      name="is_store_cmr"
                    />
                    <CheckBox
                      label={handelLabel("inter_company_sync")}
                      disabled={handelenabled("inter_company_sync")}
                      name="inter_company_sync"
                    />
                  </div>
                </section>
              )}

              <div className="flex flex-col gap-8 ">
                <label className=" text-[length:var(--customer-sub-title-2-fs)] font-[var(--alert-management-sub-title-fw)]">
                  Additional Information
                </label>
                <div
                  className="grid  gap-x-3 gap-y-0 min-w-0"
                  style={{
                    gridTemplateColumns: "repeat(auto-fit, minmax(400px, 1fr))",
                  }}
                >
                  {shouldDisplay("cmr_acquired_source") && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={acquiredList?.find(
                          (option) =>
                            option?.value ===
                            values?.general?.cmr_acquired_source
                        )}
                        label={handelLabel("cmr_acquired_source")}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelenabled("cmr_acquired_source")}
                        // errMsgContainerClass="hidden"
                        id={`general.cmr_acquired_source`}
                        placeholder={`Select ${handelLabel(
                          "cmr_acquired_source"
                        )}`}
                        options={acquiredList}
                        name={`general.cmr_acquired_source`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_balance") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_balance`}
                        placeholder={`Enter ${handelLabel("cmr_balance")}`}
                        label={handelLabel("cmr_balance")}
                        isDisabled={handelenabled("cmr_balance")}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_payment_terms") && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={paymentList?.find(
                          (option) =>
                            option?.value === values?.general?.cmr_payment_terms
                        )}
                        label={handelLabel("cmr_payment_terms")}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelenabled("cmr_payment_terms")}
                        // errMsgContainerClass="hidden"
                        id={`general.cmr_payment_terms`}
                        placeholder={`Select ${handelLabel(
                          "cmr_payment_terms"
                        )}`}
                        options={paymentList}
                        name={`general.cmr_payment_terms`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_shipping_method") && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={shippingTypeList?.find(
                          (option) =>
                            option?.value ===
                            values?.general?.cmr_shipping_method
                        )}
                        label={handelLabel("cmr_shipping_method")}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelenabled("cmr_shipping_method")}
                        // errMsgContainerClass="hidden"
                        id={`general.cmr_shipping_method`}
                        placeholder={`Select ${handelLabel(
                          "cmr_shipping_method"
                        )}`}
                        options={shippingTypeList}
                        name={`general.cmr_shipping_method`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_sector") && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={sectorList?.find(
                          (option) =>
                            option?.value === values?.general?.cmr_sector
                        )}
                        label={handelLabel("cmr_sector")}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelenabled("cmr_sector")}
                        // errMsgContainerClass="hidden"
                        id={`general.cmr_sector`}
                        placeholder={`Select ${handelLabel("cmr_sector")}`}
                        options={sectorList}
                        name={`general.cmr_sector`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}

                  {values.general.cmr_type === "business" && (
                    <>
                      {shouldDisplay("cmr_pan") && (
                        <div className="col-span-1">
                          <InputField
                            // errMsgContainerClass="hidden"
                            type="text"
                            // isRequired={true}
                            maxLength={10}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            parentClass="flex-1 flex  flex-col gap-2 w-full align-end "
                            name={`general.cmr_pan`}
                            // placeholder={`Enter ${handelLabel("cmr_pan")}`}
                            placeholder="Enter PAN"
                            // label={handelLabel("cmr_pan")}
                            label="PAN"
                            // isDisabled={handelenabled("cmr_balance")}
                            isDisabled={disabled}
                            defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                            containerClass="w-full h-min"
                          />
                        </div>
                      )}
                      {shouldDisplay("cmr_fssai") && (
                        <div className="col-span-1">
                          <InputField
                            // errMsgContainerClass="hidden"
                            // isRequired={true}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            parentClass="flex  flex-col gap-2 w-full align-end "
                            name={`general.cmr_fssai`}
                            placeholder={`Enter ${handelLabel("cmr_fssai")}`}
                            label={handelLabel("cmr_fssai")}
                            isDisabled={handelenabled("cmr_fssai")}
                            defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                            containerClass="w-full h-min"
                          />
                        </div>
                      )}
                      {shouldDisplay("cmr_dl_no") && (
                        <div className="col-span-1">
                          <InputField
                            // errMsgContainerClass="hidden"
                            // isRequired={true}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            parentClass="flex  flex-col gap-2 w-full align-end "
                            name={`general.cmr_dl_no`}
                            placeholder={`Enter ${handelLabel("cmr_dl_no")}`}
                            label={handelLabel("cmr_dl_no")}
                            isDisabled={handelenabled("cmr_dl_no")}
                            defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                            containerClass="w-full h-min"
                          />
                        </div>
                      )}

                      {shouldDisplay("cmr_tax") && (
                        <div className="col-span-1">
                          <SelectField
                            defaultValue={taxList?.find(
                              (option) =>
                                option?.value === values?.general?.cmr_tax
                            )}
                            label={handelLabel("cmr_tax")}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            general_color="true"
                            borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                            isContainer={true}
                            containerClass={`${
                              disabled ? "cursor-not-allowed" : ""
                            } w-full flex flex-col gap-2`}
                            parentClass={`${
                              disabled ? "cursor-not-allowed" : ""
                            } w-full flex flex-col gap-2`}
                            isDisabled={handelenabled("cmr_tax")}
                            // errMsgContainerClass="hidden"
                            id={`general.cmr_tax`}
                            placeholder={`Select ${handelLabel("cmr_tax")}`}
                            options={taxList}
                            name={`general.cmr_tax`}
                            isSearchable={true}
                            // isRequired={true}
                          />
                        </div>
                      )}
                      {shouldDisplay("cmr_tcs") && (
                        <div className="col-span-1">
                          <SelectField
                            defaultValue={tcslist?.find(
                              (option) =>
                                option?.value === values?.general?.cmr_tcs
                            )}
                            label={handelLabel("cmr_tcs")}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            general_color="true"
                            borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                            isContainer={true}
                            containerClass={`${
                              disabled ? "cursor-not-allowed" : ""
                            } w-full flex flex-col gap-2`}
                            parentClass={`${
                              disabled ? "cursor-not-allowed" : ""
                            } w-full flex flex-col gap-2`}
                            isDisabled={handelenabled("cmr_tcs")}
                            // errMsgContainerClass="hidden"
                            id={`general.cmr_tcs`}
                            placeholder={`Select ${handelLabel("cmr_tcs")}`}
                            options={tcslist}
                            name={`general.cmr_tcs`}
                            isSearchable={true}
                            // isRequired={true}
                          />
                        </div>
                      )}
                      {shouldDisplay("cmr_tds") && (
                        <div className="col-span-1">
                          <SelectField
                            defaultValue={tdslist?.find(
                              (option) =>
                                option?.value === values?.general?.cmr_tds
                            )}
                            label={handelLabel("cmr_tds")}
                            labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                            general_color="true"
                            borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                            isContainer={true}
                            containerClass={`${
                              disabled ? "cursor-not-allowed" : ""
                            } w-full flex flex-col gap-2`}
                            parentClass={`${
                              disabled ? "cursor-not-allowed" : ""
                            } w-full flex flex-col gap-2`}
                            isDisabled={handelenabled("cmr_tds")}
                            // errMsgContainerClass="hidden"
                            id={`general.cmr_tds`}
                            placeholder={`Select ${handelLabel("cmr_tds")}`}
                            options={tdslist}
                            name={`general.cmr_tds`}
                            isSearchable={true}
                            // isRequired={true}
                          />
                        </div>
                      )}
                      {(shouldDisplay("cmr_fssai_certificate") ||
                        shouldDisplay("cmr_fssai_certificate")) && (
                        <div className="col-span-1">
                          <div className="flex fkex-col flex-1 gap-3">
                            {shouldDisplay("cmr_fssai_certificate") && (
                              <UploadImg
                                title={handelLabel("cmr_fssai_certificate")}
                                name={"cmr_fssai_certificate"}
                                onUploadSuccess={handleUploadSuccess}
                                data={trimApiPrefix(
                                  values.general.cmr_fssai_certificate
                                )}
                              />
                            )}
                            {shouldDisplay("cmr_fssai_certificate") && (
                              <UploadImg
                                title={handelLabel("cmr_dl_certificate")}
                                name={"cmr_dl_certificate"}
                                onUploadSuccess={handleUploadSuccess}
                                data={trimApiPrefix(
                                  values.general.cmr_dl_certificate
                                )}
                              />
                            )}
                          </div>
                        </div>
                      )}
                    </>
                  )}

                  {shouldDisplay("cmr_town") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}

                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_town`}
                        placeholder={`Enter ${handelLabel("cmr_town")}`}
                        label={handelLabel("cmr_town")}
                        // isDisabled={handelenabled("cmr_town")}
                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_village") && (
                    <div className="col-span-1">
                      <SelectField
                        defaultValue={values?.general?.areaList?.find(
                          (option) =>
                            option?.value === values?.general?.cmr_village
                        )}
                        label={handelLabel("cmr_village")}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        general_color="true"
                        borderclass="border border-[var(--pay-met-input-border)] rounded-lg"
                        isContainer={true}
                        containerClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        parentClass={`${
                          disabled ? "cursor-not-allowed" : ""
                        } w-full flex flex-col gap-2`}
                        isDisabled={handelenabled("cmr_village")}
                        // errMsgContainerClass="hidden"
                        id={`general.cmr_village`}
                        placeholder={`Select ${handelLabel("cmr_village")}`}
                        options={values?.general?.areaList}
                        name={`general.cmr_village`}
                        isSearchable={true}
                        // isRequired={true}
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_state") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_state`}
                        placeholder={`Enter ${handelLabel("cmr_state")}`}
                        label={handelLabel("cmr_state")}
                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_city") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_city`}
                        placeholder={`Enter ${handelLabel("cmr_city")}`}
                        label={handelLabel("cmr_city")}
                        isDisabled={true}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_pincode") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        maxLength={6}
                        minLength={6}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_pincode`}
                        placeholder={`Enter ${handelLabel("cmr_pincode")}`}
                        label={handelLabel("cmr_pincode")}
                        isDisabled={handelenabled("cmr_pincode")}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                        handleChange={(e) => {
                          fetchAddressFn(e?.target?.value, setFieldValue);
                        }}
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_latitude") && (
                    <div className="col-span-1">
                      <InputField
                        // errMsgContainerClass="hidden"
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass="flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_latitude`}
                        placeholder={`Enter Latitude`}
                        // label={handelLabel("cmr_latitude")}
                        label="Latitude"
                        isDisabled={handelenabled("cmr_latitude")}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                    </div>
                  )}
                  {shouldDisplay("cmr_longitude") && (
                    <div className="col-span-1">
                      {/* <div className="h-full mt-auto w-full"> */}
                      <InputField
                        // errMsgContainerClass="hidden"
                        // isRequired={true}
                        labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                        parentClass=" flex  flex-col gap-2 w-full align-end "
                        name={`general.cmr_longitude`}
                        placeholder={`Enter Longitude`}
                        label="Longitude"
                        isDisabled={handelenabled("cmr_longitude")}
                        defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                        containerClass="w-full h-min"
                      />
                      {/* </div> */}
                    </div>
                  )}
                </div>
              </div>
              {shouldDisplay("cmr_address") && (
                <div className="flex flex-col gap-2">
                  <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                    {handelLabel("cmr_address")} (max 250 Characters)
                  </label>
                  <TextAreaField
                    maxLength={250}
                    name={`general.cmr_address`}
                    placeholder="Enter Address"
                    labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                    parentClass="flex  flex-col gap-2 w-full align-end "
                    label=""
                    isDisabled={handelenabled("cmr_address")}
                    defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                    containerClass="flex flex-col gap-2 w-full "
                  />
                </div>
              )}
              {shouldDisplay("cmr_remarks") && (
                <div className="flex flex-col gap-2">
                  <label className=" text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)]">
                    {handelLabel("cmr_remarks")}
                  </label>
                  <TextAreaField
                    name={`general.cmr_remarks`}
                    placeholder="Enter Remarks"
                    labelClass={`text-[var(--alert-management-label-color)] text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-sub-title-fw)] w-full`}
                    parentClass="flex  flex-col gap-2 w-full align-end "
                    label=""
                    isDisabled={handelenabled("cmr_remarks")}
                    defaultInputClass={`min-h-[42px] rounded-[8px] px-2 bg-[var(--input-bg)] text-[var(--input-color)] text-[length:var(--input-font-size)] font-[var(--alert-management-input-fw)] rounded  placeholder:text-[var(--input-place-color)] placeholder:text-[length:var(--input-place-font-size)] placeholder:font-[var(--input-place-font-weight)] focus:outline-none focus:none focus:text-[var(--input-color)] 
`}
                    containerClass="flex flex-col gap-2 w-full "
                  />
                </div>
              )}
            </div>
            {page !== "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-between  sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  onclkFn={async () => navigate("/admin/customer")}
                  text={<span>Cancel</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
     cursor-pointer
    text-[var(--primary-button-bg-color)]
    border border-[var(--primary-button-bg-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  isDisabled={disabled}
                  // icon={<Save size={14} />}
                  // onclkFn={onSave}
                  text={<span>Save</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="submit"
                />
              </div>
            )}
            {page == "view" && (
              <div
                style={{
                  bottom: "0",
                }}
                className="flex justify-end sticky bg-white py-4  "
              >
                <AddButton
                  prefixIcon={false}
                  // ref={submitRef}
                  // isDisabled={false}
                  // icon={<Save size={14} />}
                  onclkFn={() =>
                    navigate(`/edit-customer-admin/${values?.general?.cmr_id}`)
                  }
                  text={<span>Edit</span>}
                  className="
    flex items-center px-3 py-2  whitespace-nowrap rounded-md gap-[8px]
    bg-[var(--primary-button-bg-color)] cursor-pointer
    text-[var(--primary-button-fg-color)]
    border border-[var(--primary-button-bg-color)]
    hover:bg-[var(--primary-button-hover-color)]
    text-[length:var(--primary-button-create-fs)]
    font-[var(--primary-button-font-weight)]
    "
                  type="button"
                />
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  );
}

export default General;

// function CheckBox({ label, disabled }) {
//   return (
//     <div className="flex flex-row w-full items-center gap-2 py-3 rounded-lg bg-[var(--alert-management-variable-bg)]">
//       <input
//         type="checkbox"
//         // checked={isChecked}
//         disabled={disabled}
//         // onChange={handleCheckboxChange}
//         className="custom-checkbox form-check-input ml-[3px]"
//       />
//       <label className="text-[length:var(--alert-management-label-fs)] font-[var(--alert-management-variable-fw)]">
//         {label}{" "}
//       </label>
//     </div>
//   );
// }

const CreateAreaList = () => {
  const { setFieldValue, initialValues } = useFormikContext();
  const pincode = initialValues.general.cmr_pincode;
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchAddressInitially = () => {
      // Only proceed if pincode is exactly 6 digits
      if (pincode?.length !== 6) return;

      dispatch(
        pincodeListAction(
          pincode,
          (response) => {
            const postOffices = response?.[0]?.PostOffice;
            if (response?.[0]?.Status !== "Error" && postOffices) {
              const areaOptions = postOffices.map((item) => ({
                label: item.Name,
                value: item.Name,
              }));
              setFieldValue("general.areaList", areaOptions);
            }
          },
          () => {} // Error callback
        )
      );
    };

    // Call the function immediately when component mounts
    fetchAddressInitially();
  }, []); // Empty dependency array to run only once on mount

  return null;
};
